import { h } from 'preact';
import styled from 'styled-components';
import type { ComponentChildren } from 'preact';

interface FormControlProps {
	id?: string;
	label: string;
	error?: boolean;
	required?: boolean;
	helperText?: string;
	children: ComponentChildren;
}

const FormControlStyled = styled.div`
	position: relative;
	width: '100%';
`;

const Label = styled.label`
	display: block;
	font-family: Inter;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 1;
	margin-bottom: 5px;
	width: '100%';
`;

const Error = styled.div`
	width: '100%';
`;

export const FormControl = ({
	id,
	label,
	required,
	error,
	helperText,
	children,
}: FormControlProps) => {
	return (
		<FormControlStyled>
			{children}
			{error && helperText && <Error>{helperText}</Error>}
		</FormControlStyled>
	);
};
